import React, { useEffect, useState } from 'react'
import FormDrawer from 'components/__new/common/form-drawer-old';
import { ButtonLoader } from 'components/__new/common/form';


    export const ApprovalRequestModal = ({isOpen, onProceed, onCancel, loading}) => {
        return (
            <FormDrawer display="center" size="md" isOpen={isOpen} setIsOpen={onCancel}>
                    <div className="p-7 pb-4">
                        <div className="mb-5">
                            <p className="mb-1 font-medium capitalize">Send For Approval</p>
                        </div>
                        
                        <div className="text-[#4a5564]">Are you sure you want to perform this action?</div>
                        
                        <div className="flex items-center pt-8 pb-3">
                            <button onClick={onCancel} className="btn btn-md btn-transparent-primary mr-4 w-2/4">Cancel</button>
                            <ButtonLoader type="button" loading={loading} onClick={onProceed} className="btn btn-ep-primary w-2/4">
                                Yes
                            </ButtonLoader>
                        </div>
                    </div>
                </FormDrawer>
        )
    }


    export const PayrollApprovalConfirmation = ({isOpen, onProceed, onCancel, loading}) => {
        
        const [comment, setComment] = useState("");
        
        useEffect(() => {
            setComment("");
        }, [])
        
        const closeModal = () => {
            onCancel();
            setComment("");
        }
        
        return (
            <FormDrawer display="center" size="md" isOpen={isOpen} setIsOpen={closeModal}>
                    <div className="p-7 pb-4">
                        <div className="mb-5">
                            <p className="mb-1 font-medium capitalize">Reason For Approval</p>
                        </div>
                        
                        <div className="mt-6">
                            <div className="form-group mb-0">
                                <label className="text-[#4A5564]">
                                    Approval Reason (Optional)
                                </label>
                                <textarea
                                    style={{resize: "none"}}
                                    label="Comment"
                                    rows="6"
                                    required
                                    className="form-input-textarea"
                                    placeholder="Enter reasons"
                                    value={comment}
                                    onChange={(e) => setComment(e.target.value)}
                                />
                            </div>
                        </div>
                        
                        <div className="flex items-center pt-8 pb-3">
                            <button onClick={closeModal} className="btn btn-md btn-transparent-primary mr-4 w-2/4">Cancel</button>
                            <ButtonLoader type="button" loading={loading} onClick={() => onProceed(comment)} className="btn btn-ep-primary w-2/4">
                                Approve
                            </ButtonLoader>
                        </div>
                    </div>
                </FormDrawer>
        )
    }


    export const PayrollRejectionConfirmation = ({isOpen, onProceed, onCancel, loading}) => {
        
        const [comment, setComment] = useState("");
        
        useEffect(() => {
            setComment("");
        }, [])
        
        const closeModal = () => {
            onCancel();
            setComment("");
        }
        
        return (
            <FormDrawer display="center" size="md" isOpen={isOpen} setIsOpen={closeModal}>
                    <div className="p-7 pb-4">
                        <div className="mb-5">
                            <p className="mb-1 font-medium capitalize">Reason For Rejection</p>
                        </div>
                        
                        <div className="mt-6">
                            <div className="form-group mb-0">
                                <label className="text-[#4A5564]">
                                    Rejection Reason
                                </label>
                                <textarea
                                    style={{resize: "none"}}
                                    label="Comment"
                                    rows="6"
                                    required
                                    className="form-input-textarea"
                                    placeholder="Enter reasons"
                                    value={comment}
                                    onChange={(e) => setComment(e.target.value)}
                                />
                            </div>
                        </div>
                        
                        <div className="flex items-center pt-8 pb-3">
                            <button onClick={closeModal} className="btn btn-md btn-transparent-primary mr-4 w-2/4">Cancel</button>
                            <ButtonLoader type="button" disabled={!comment?.length} loading={loading} onClick={() => onProceed(comment)} className="btn bg-ep-danger text-white w-2/4">
                                Reject
                            </ButtonLoader>
                        </div>
                    </div>
                </FormDrawer>
        )
    }